/**
 * Links a job-detail salary stat row to its matching /salary/{role} hub page.
 * Duplicated (not imported) from lambda/utils/salaryAggregation.ts's slugifyRole —
 * same convention as CURRENCY_RATES in ../utils/salaryConversion.ts — to avoid pulling
 * lambda code into the client bundle. Keep in sync with that implementation.
 */
function slugifyRole(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Row types on the job-detail salary chart that have a matching hub page today (TITLE, TITLE+LOCATION). */
const HUB_LINKED_TYPES = new Set(['title', 'titleLocation']);

export interface BuildSalaryHubLinkParams {
  /** SalaryRange.type from SalaryDistributionChart — only 'title'/'titleLocation' resolve to a hub page. */
  type: string;
  jobTitle?: string | null;
  locale?: string;
}

/** Returns the /salary/{role} hub URL for a stat row, or null if that dimension has no hub page yet. */
export function buildSalaryHubLink({ type, jobTitle, locale = 'en' }: BuildSalaryHubLinkParams): string | null {
  if (!jobTitle || !HUB_LINKED_TYPES.has(type)) return null;
  const slug = slugifyRole(jobTitle);
  if (!slug) return null;
  const localePrefix = locale === 'en' ? '' : `/${locale}`;
  return `${localePrefix}/salary/${slug}`;
}
